module.exports = __webpack_public_path__ + "img/scene_file.1923917a.webp";